import React from 'react';
import * as css from 'styles'
import { connect } from 'react-redux';
import styled from 'react-emotion'
import propStyles from 'prop-styles'
// import ReactPlayer from 'react-player'

import titleFromSlug from 'utils/titleFromSlug';

import View from 'components/View/View';
import Text from 'components/Text/Text';
import FadeIn from '../components/Animated/FadeIn';
import Link from '../components/Link/Link';
import Loading from '../components/Loading/Loading';
import Meta from '../components/Meta/Meta'
import Img from '../components/Img/Img'
import Icon from './Icon';
import Ticker from './Ticker';


const Grid = styled('div')({
  display: 'grid',
  gridGap: '4rem',
  gridTemplateColumns: '1fr 1fr', //'repeat(auto-fit, minmax(400px, 1fr))',
  'align-items': 'center',
  'justify-content': 'center',
  [css.breakpoint.l_down]: {
    gridGap: '2em',
  },
  [css.breakpoint.m_down]: {
    // gridGap: '2rem',
    gridTemplateColumns: '1fr',
  },
  [css.breakpoint.s_down]: {
    gridGap: '1em',
  },
})

const Cell = styled('div')({
  width: '100%',
  maxWidth: '100%',
  [css.breakpoint.m_down]: {
    gridColumnEnd: 'span 1 !important',
  },
}, ({ type }) => {
  const row_types = {
    // Defined in ACF setup - as a select dropdown.
    width_50: {
      span: false,
    },
    width_100: {
      span: 2,
    },
    width_50_contain: {
      span: false,
      padding: '0 4rem',
      [css.breakpoint.m_down]: {
        padding: '0.5em 1.5em !important',
      },
    },
    width_100_contain: {
      span: 2,
      // height: '110vh !important', 
    },
  }
  let row = row_types[type]
  return {
    gridColumnEnd: row.span ? `span ${row.span}` : 'auto',
  }
})

const Sizer = styled('div')({
  [css.breakpoint.m_down]: {
    width: '100% !important',
    height: 'auto !important',
  },
}, ({ type, portrait }) => {
  const types = {
    width_50: {},
    width_100: {},
    width_50_contain: {
      margin: '0 auto',
      width: '70%',
      [css.breakpoint.m_down]: {
        width: '80% !important',
        height: 'auto !important',
      },
    },
    width_100_contain: {
      margin: '0 auto',
      width: portrait ? '50%' : '70%',
      [css.breakpoint.m_down]: {
        width: '80% !important',
        height: 'auto !important',
      },
    },
  }
  return types[type] || {}
})

const DetailsGrid = styled('div')({
  margin: `${css.space.l} 0 0 0`,
  display: 'grid',
  gridGap: '4rem',
  gridTemplateColumns: '1fr 4fr 1fr',

  [css.breakpoint.m_down]: {
    gridGap: '2rem !important',
    gridTemplateColumns: '1fr 1fr !important',
  },
})

const DetailsCell = styled('div')({
  '& a': {
    textDecoration: 'underline',
  },
  [css.breakpoint.m_down]: {
    order: -1,
    gridColumnEnd: 'span 2',
  }
})

const DetailsNav = styled('div')({
  '& a': {
    '&:hover':{
      textDecoration: 'underline',
      // borderBottom: '1px solid black',
    }
  },
})

const Content = styled('div')({
  '& a': {
    textDecoration: 'underline',
  },
})

const VideoWrapper = styled('div')({
  width: '100%',
  height: '0px',
  position: 'relative',
  '& iframe': {
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    width: '100%',
    height: '100%',
  }
},({aspect}) => {
// console.log("TCL: aspect", aspect)
  return {
    paddingTop: aspect > 100 ? 'none' : `${aspect}%`,
    height: aspect > 100 ? '600px' : 'none',
  }
})

class Video extends React.Component {
  state = {
    data: {
      html: '',
      width: 800,
      height: 450,
      aspect: '56.25%',
    }
  }

  componentDidMount() {
    const video_type = 'https://noembed.com/embed?url='
    // url.includes('vimeo') ? 'https://vimeo.com/api/oembed.json?url=':
    // url.includes('youtube') ? 'https://www.youtube.com/oembed?url=': 
    // null
    const video_extension =
    this.props.url.includes('vimeo') ? '?title=false&byline=false&portrait=false' :
    this.props.url.includes('youtube') ? '&showinfo=0&rel=0' : ''
    // this.props.url.includes('vimeo') ? '' :

    const url = `${video_type}${this.props.url}${video_extension}`
    console.log(url)

    fetch(url)
      .then(response => response.json())
      .then(data => {
        console.log(data)
        this.setState({ ...data })
      })
      .catch(error => {
        console.log(error)
      })
  }

  render(){
    return (
      <VideoWrapper 
        dangerouslySetInnerHTML={{ __html: this.state.html }} 
        aspect={(parseInt(this.state.height) / parseInt(this.state.width)) * 100}
      />
    )
  }
}

const Project = ({ content, status, slug, error }) => {

  const page = (content) ? content[0] : null //{ acf:{ images: [], meta_description: '' }, prev: null, next: null }
  const acf = (page && page.acf) ? page.acf : null
  const metaDescription = acf ? acf.meta_description : null;
  const ellipsis = '&nbsp;&nbsp;&nbsp;.&nbsp;.&nbsp;.&nbsp;&nbsp;&nbsp;';

  // console.log(page);
  let column = 1;  

  window.scrollTo(0, 0)

  return (
    <View padding="0 0 4em 0">
      <Meta title={error ? 'Project Not Found' : titleFromSlug(slug)} description={metaDescription} />
      
      {page && (acf.credits.length || acf.services.length || acf.ticker_text) && (
        <a href="#credits">
          <Ticker>
          <span dangerouslySetInnerHTML={{__html: 
            acf.ticker_text ?
              // Override
              `${acf.ticker_text.trim()}${ellipsis}` :
              // OR Construct
              `${acf.credits && acf.credits.map((row, i) =>
                `${row.title.trim()}:&nbsp;${row.name.trim()}${ellipsis}`
              ).join('')}` +
              // `${acf.credits && acf.services && ellipsis}` + 
              `${acf.services ? 'Services:&nbsp;' : ''}` +
              `${acf.services ? acf.services.map((row, i) => 
                `${row.service.trim()}`
              ).join(',&nbsp;') : ''}` +
              `${acf.services ? ellipsis : ''}`
          }} />
          </Ticker>
        </a>
      )}

      <Loading 
        status={status}
        errormessage="Project Not Found" 
        height="80vh"
        // nospinner
      >

        <Grid>
        {page && (acf.images) && acf.images.map((row, i) => {
        // const portrait = row.image.height > row.image.width;  
        if (row.image) {
          var desktop_image = row.row_type.includes('50') ? row.image.sizes.get_medium : row.image.sizes.get_large
          var mobile_image = row.image.sizes.medium_large
          var image_url = window.innerWidth > 435 ? desktop_image : mobile_image
        }
        return(
          // <Img
          //   src={image_url}
          //   width={row.image.width}
          //   height={row.image.height}
          //   nospinner
          // />
          <Cell key={'cell'+i} type={row.row_type}>
            <Sizer 
              type={row.row_type} 
              column={row.row_type.includes('50') ? column++ : false}
              portrait={row.image && (row.image.width < row.image.height)}
            >
              {row.video ? (
                <Video 
                  url={row.video}
                />
              ) : row.image ? (
                <Img 
                  src={image_url} 
                  width={row.image.width} 
                  height={row.image.height} 
                  nospinner 
                />
              ) : null}
            </Sizer>

            {i === 0 && acf.description && (
              <Content style={{ padding: `0 0 ${css.space.s} 0` }}>
                <Text><span dangerouslySetInnerHTML={{ __html: acf.description }} /></Text>
              </Content>
            )}
          </Cell>
        )})}
        </Grid>

        {page && (
        <DetailsGrid id="credits"> 
          <DetailsNav>
            {page.prev && <Link to={`/projects/${page.prev.slug}`}><Icon type="triangle" style={{marginRight: '0.5rem'}} />PREV</Link>}
          </DetailsNav>
          
          <DetailsCell>
            <View autogrid>
              <View>
                {(acf.credits) && acf.credits.map((row, i) => (
                  <View key={'creditsRow'+i} grid>
                    <View style={{textTransform: 'uppercase'}}>{row.title}</View>
                    <View>
                      {row.url ? <a href={row.url} target="_blank">{row.name}</a> : row.name}
                    </View>
                  </View>
                ))}
              </View>

              {(acf.services) && (
                <View grid>
                  <View style={{textTransform: 'uppercase'}}>Services</View>
                  <View>
                    {acf.services.map((row, i) => (
                      <View key={'servicesRow'+i}>{row.service}</View>
                    ))}
                  </View>
                </View> 
              )}
            </View>
          </DetailsCell>

          <DetailsNav style={{textAlign: 'right'}}>
            {page.next && <Link to={`/projects/${page.next.slug}`}>NEXT<Icon type="triangle" rotate={180} style={{ marginLeft: '0.5rem' }} /></Link>}
          </DetailsNav>
        </DetailsGrid>
        )}

      </Loading>
    </View>
  ) // : null
};

const mapState = state => ({
  location: state.location.type,
  kind: state.location.kind,
  slug: state.location.payload.id,
  status: state.project.status,
  content: state.project.data,
  error: state.project.error,
})

export default connect(mapState)(Project);




// WEBPACK FOOTER //
// ./src/containers/Project.js